import React from "react";
import { Controller, useForm } from "react-hook-form";
import { v4 } from "uuid";

export function Form({ defaultValues, children, onSubmit }) {
	const { handleSubmit, register } = useForm({ defaultValues });

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			{Array.isArray(children)
				? children.map(child => {
						return child.props.name
							? React.createElement(child.type, {
									...{
										...child.props,
										register,
										key: child.props.name,
									},
							  })
							: child;
				  })
				: children}
		</form>
	);
}

export function Input({ register, name, ...rest }) {
	return <input {...register(name)} {...rest} />;
}

export function Select({ register, options, name, selectedValue, ...rest }) {
	if (rest?.control)
		return (
			<Controller
				name={name}
				control={rest.control}
				render={({ field }) => (
					<select {...field} {...rest}>
						<option value="">اختر</option>
						{options.map((value, index) => (
							<option
								value={value.slug}
								selected={value.slug === field?.value}
								key={index}
							>
								{value?.name?.ar ?? value.name}
							</option>
						))}
					</select>
				)}
			/>
		);

	return (
		<select {...register(name)} {...rest}>
			<option value="">اختر</option>
			{options.map((value, index) => (
				<option
					value={value.slug}
					selected={value.slug === selectedValue}
					key={index}
				>
					{value?.name?.ar ?? value.name}
				</option>
			))}
		</select>
	);
}
